// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/thunderstorm-penetration.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/thunderstorm-penetration/thunderstorm-penetration.js';

mount([g0]);
